import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=2830c7a2&scoped=true&"
var script = {}
import style0 from "./Support.vue?vue&type=style&index=0&id=2830c7a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830c7a2",
  null
  
)

export default component.exports